import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-downline-deposit-withdraw-modal',
  templateUrl: './downline-deposit-withdraw-modal.component.html',
  styleUrls: ['./downline-deposit-withdraw-modal.component.scss']
})
export class DownlineDepositWithdrawModalComponent implements OnInit {
  @Input() playerUuid: string;

  public isLoading = false;
  public data: any = {};
  public filter: any = {
    date_from: '',
    date_to: ''
  };
  public today = '';
  public rangeError = '';

  constructor(
    public activeModal: NgbActiveModal,
    private http: HttpService
  ) { }

  ngOnInit(): void {
    this.today = this.formatDate(new Date());
    this.load();
  }

  async load() {
    if (!this.playerUuid) {
      return;
    }

    if (!this.validateRange()) {
      return;
    }

    this.isLoading = true;
    this.data = await this.http.post('/admin/player/deposit-withdraw-summary', {
      player_uuid: this.playerUuid,
      date_from: this.filter.date_from || null,
      date_to: this.filter.date_to || null
    });
    this.isLoading = false;
  }

  async clearDateFilter() {
    this.filter.date_from = '';
    this.filter.date_to = '';
    await this.load();
  }

  validateRange() {
    this.rangeError = '';

    if (this.filter.date_from && this.filter.date_to && this.filter.date_from > this.filter.date_to) {
      this.rangeError = 'From date cannot be after to date';
      return false;
    }

    return true;
  }

  getPeriodText() {
    if (this.filter.date_from && this.filter.date_to) {
      return `${this.filter.date_from} to ${this.filter.date_to}`;
    }

    if (this.filter.date_from) {
      return `${this.filter.date_from} to now`;
    }

    if (this.filter.date_to) {
      return `First transaction to ${this.filter.date_to}`;
    }

    return 'Since first transaction to now';
  }

  private formatDate(date: Date) {
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  }
}
